import { bulkConfigurationApiUrl } from "../../bulkBaseUrl";

/** Key for identifying and caching {@link https://react-query.tanstack.com/overview react-query} requests */
export const dimensionItemsKey = "dimensionItems";

export const measuresUrl = `${bulkConfigurationApiUrl}/measures`;

export const fieldsUrl = `${bulkConfigurationApiUrl}/configuration`;
